import * as React from 'react';

import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';

export interface PublishedConnectionSpaceFavoriteRedirectProps {
  readonly publishedConnectionId: string;
  readonly urls: SpacesSiteUrls;
}

export const PublishedConnectionSpaceFavoriteRedirect: React.FunctionComponent<PublishedConnectionSpaceFavoriteRedirectProps> = props => {
  // TODO - achristian - 2020-01-23 - TFSID:1059566 - Finish the implementation of PublishedConnectionSpaceFavoriteRedirect.
  return null;
};
